// exports object of languages to be used in other files after destructuring
// highlight selection and use ctrl + / to enable/disable comments and language
const translate = {
    en: {
    "Join Wait List":"Join Wait List",
    "...joining":"...joining",
    "Click here to agree to receive email/SMS alerts from Collinson services regarding Wait list updates":"Click here to agree to receive email/SMS alerts from Collinson services regarding Wait list updates",
    "Welcome to":"Welcome to",
    "Passenger Name":"Passenger Name",
    "Email":"Email",
    "Guests":"Guests",
    "Departure Time":"Departure Time",
    "Thank you":"Thank you",
    "wait list":"wait list",
    "Please enter a departure time":"Please enter a departure time",
    "Please enter a valid email address":"Please enter a valid email address",
    "Please enter your name. Length must be greater than 2 characers":"Please enter your name. Length must be greater than 2 characers",
    "We will send you an email and/or SMS once space is available.":"We will send you an email and/or SMS once space is available",
    "You have been successfully added to the":"You have been successfully added to the",
    "Ok":"Ok",
    "Length must be greater than 2 characers.":"Length must be greater than 2 characers.",
    "Must enter a valid email address.":"Must enter a valid email address.",
    "Email incorrect format.":"Email incorrect format.",
    "Please enter a departure time.":"Please enter a departure time.",
    "Missing environment input":"Missing environment input",
    "Missing lounge code.":"Missing lounge code.",
    "Missing name.":"Missing name.",
    "Missing email.":"Missing email.",
    "Missing phone or incorrect length.":"Missing phone or incorrect length.",
    "Missing guests or not within range.":"Missing guests or not within range.",
    "Missing departure time.":"Missing departure time.",
    "Guests must be 1 or more.":"Guests must be 1 or more.",
    "Please enter a valid email address.":"Please enter a valid email address.",
    "Please provide an email or phone number.":"Please provide an email or phone number.",
    "Please use the right area code and length for this region.":"Please use the right area code and length for this region.",
    "Provide your name, flight information, email, and/or phone number so that we may contact you about lounge availability.":"Provide your name, flight information, email, and/or phone number so that we may contact you about lounge availability.",
    "I have read, understand, and agree to the ":"I have read, understand, and agree to the ",
    "Terms and Conditions": "Terms and Conditions",
    " for this platform. ":" for this platform. ",
    "Terms And Conditions": "Terms And Conditions",
    "Close": "Close",
    "Your email": "Your email",
    "will be removed and will no longer be used to contact you.":"will be removed and will no longer be used to contact you.",
    "Please click the button below to confirm.": "Please click the button below to confirm.",
    "Confirm": "Confirm",
    "Your email has been successfully removed.": "Your email has been successfully removed.",
    "...processing request": "...processing request",
    "Privacy Policy":"Privacy Policy",
    "Privacy Policy | Collinson Group":"Privacy Policy | Collinson Group",
    "Privacy Policy | The Club":"Privacy Policy | The Club",
    "Missing flight number.":"Missing flight number.",
    "Please enter a flight number":"Please enter a flight number",
    "Please accept the terms and conditions.":"Please accept the terms and conditions.",
    "Flight Number - E.g 1234": "Flight Number - E.g 1234",
    "Flight Airline": "Flight Airline",
    "Infants under 2 yrs": "Infants under 2 yrs",
    "Guest Count": "Guest Count",
    "Please select an airline.": "Please select an airline.",
    "Please enter the flight number.": "Please enter the flight number.",
    "Please, select a number between 0 and 9.": "Please, select a number between 0 and 9.",
    "Can't have more than 4 digits.": "Can't have more than 4 digits.",
    "Must be above 0.": "Must be above 0.",
    "Incorrect flight number format.": "Incorrect flight number format.",
    "Programs": "Programs",
    },
    es: {
    "Join Wait List":"Únase a la lista de espera",
    "...joining":"...unión",
    "Click here to agree to receive email/SMS alerts from Collinson services regarding Wait list updates":"Haga clic aquí para aceptar recibir alertas por correo electrónico/SMS de los servicios de Collinson con respecto a las actualizaciones de la lista de espera",
    "Welcome to":"Bienvenido a",
    "Passenger Name":"Nombre del Pasajero",
    "Email":"Correo electrónico",
    "Guests":"Invitados",
    "Departure Time":"Hora de Salida",
    "Thank you":"Gracias",
    "wait list":"lista de espera",
    "Please enter a departure time":"Ingrese una hora de salida",
    "Please enter a valid email address":"Ingrese una dirección de correo electrónico válida",
    "Please enter your name. Length must be greater than 2 characers":"Por favor ingrese su nombre. La longitud debe ser mayor a 2 caracteres",
    "We will send you an email and/or SMS once space is available.":"Le enviaremos un correo electrónico y/o SMS una vez que haya espacio disponible",
    "You have been successfully added to the":"Ha sido agregado exitosamente a",
    "Ok":"De acuerdo",
    "Length must be greater than 2 characers.":"La longitud debe ser mayor a 2 caracteres.",
    "Must enter a valid email address.":"Debe ingresar una dirección de correo electrónico válida.",
    "Email incorrect format.":"Email formato incorrecto.",
    "Please enter a departure time.":"Por favor ingrese una hora de salida.",
    "Missing environment input":"Falta entrada de entorno",
    "Missing lounge code.":"Falta el código del salón.",
    "Missing name.":"Nombre faltante.",
    "Missing email.":"Correo electrónico faltante.",
    "Missing phone or incorrect length.":"Proporcione teléfono y longitud correcta.",
    "Missing guests or not within range.":"Invitados faltantes o no dentro del alcance.",
    "Missing departure time.":"Falta la hora de salida.",
    "Guests must be more 1 or more.":"Los huéspedes deben ser 1 o más.",
    "Please enter a valid email address.":"Por favor, introduce una dirección de correo electrónico válida.",
    "Please provide an email or phone number.":"Proporcione un correo electrónico o número de teléfono.",
    "Please use the right area code and length for this region.":"Utilice el código de área y la longitud correctos para esta región.",
    "Provide your name, flight information, email, and/or phone number so that we may contact you about lounge availability.":"Proporcione su nombre, información de vuelo, correo electrónico y/o número de teléfono para que podamos comunicarnos con usted acerca de la disponibilidad de salas VIP.",
    "I have read, understand, and agree to the ": "He leído, comprendo y acepto las ",
    "Terms and Conditions":"Términos y condiciones",
    " for this platform. ": " para esta plataforma. ",
    "Terms And Conditions": "Términos y condiciones",
    "Close": "Cerrar",
    "Your email": "Tu correo electrónico",
    "will be removed and will no longer be used to contact you.":"se eliminará y ya no se utilizará para contactarlo.",
    "Please click the button below to confirm.": "Por favor, haga clic en el botón de abajo para confirmar.",
    "Confirm": "Confirmar",
    "Your email has been successfully removed.":"Su correo electrónico ha sido eliminado con éxito.",
    "...processing request": "...Procesando",
    "Privacy Policy | Collinson Group":"Política de Privacidad | Collinson Group",
    "Privacy Policy | The Club":"Política de Privacidad | The Club",
    "Missing flight number.":"Número de vuelo faltante.",
    "Please enter a flight number":"Por favor introduzca un número de vuelo",
    "Please accept the terms and conditions.":"Por favor acepte los términos y condiciones.",
    "Flight Number - E.g 1234": "Número de vuelo - ej. 1234",
    "Flight Airline": "Aerolínea",
    "Infants under 2 yrs": "Niños menores de 2 años",
    "Guest Count": "Cantidad de Invitados",
    "Please select an airline.": "Por favor seleccione una aerolínea",
    "Please enter the flight number.": "Por favor introduzca el número de vuelo.",
    "Please, select a number between 0 and 9.": "Por favor seleccione un número entre 0 y 9.",
    "Can't have more than 4 digits.": "No puede tener más de 4 dígitos.",
    "Must be above 0.": "Debe ser superior a 0.",
    "Incorrect flight number format.": "Formato incorrecto del número de vuelo.",
    "Programs": "Programas",
    },
    pt: {
    "Join Wait List":"Entrar na lista de espera",
    "...joining":"...juntando-se",
    "Click here to agree to receive email/SMS alerts from Collinson services regarding Wait list updates":"Clique aqui para concordar em receber alertas por e-mail/SMS dos serviços da Collinson sobre atualizações da lista de espera",
    "Welcome to":"Bem-vindo ao",
    "Passenger Name":"Nome do passageiro",
    "Email":"E-mail",
    "Guests":"Convidados",
    "Departure Time":"Hora de partida",
    "Thank you":"Obrigado",
    "wait list":"lista de espera",
    "Please enter a departure time":"Insira um horário de partida",
    "Please enter a valid email address":"Por favor insira um endereço de e-mail válido",
    "Please enter your name. Length must be greater than 2 characers":"Digite seu nome. O comprimento deve ser maior que 2 caracteres",
    "We will send you an email and/or SMS once space is available.":"Enviaremos um e-mail e/ou SMS assim que o espaço estiver disponível",
    "You have been successfully added to the":"Você foi adicionado com sucesso ao",
    "Ok":"Ok",
    "Length must be greater than 2 characers.":"Comprimento deve ser maior que 2 caracteres.",
    "Must enter a valid email address.":"Deve inserir um endereço de e-mail válido.",
    "Email incorrect format.":"Email incorrect format.",
    "Please enter a departure time.":"Por favor, insira um horário de partida.",
    "Missing environment input":"Faltando entrada de ambiente",
    "Missing lounge code.":"Código da sala VIP ausente.",
    "Missing name.":"Nome ausente.",
    "Missing email.":"E-mail ausente.",
    "Missing phone or incorrect length.":"Telefone ausente ou comprimento incorreto.",
    "Missing guests or not within range.":"Convidados ausentes ou fora do alcance.",
    "Missing departure time.":"Falta hora de partida.",
    "Guests must be more 1 or more.": "Os convidados devem ser 1 ou mais.",
    "Please enter a valid email address.":"Por favor insira um endereço de e-mail válido.",
    "Please provide an email or phone number.":"Por favor, forneça um e-mail ou número de telefone.",
    "Please use the right area code and length for this region.":"Use o código de área e o comprimento corretos para esta região.",
    "Provide your name, flight information, email, and/or phone number so that we may contact you about lounge availability.": "Forneça seu nome, informações do voo, e-mail e/ou número de telefone para que possamos entrar em contato com você sobre a disponibilidade do lounge.",
    "I have read, understand, and agree to the ":"Li, entendi e concordo com os ",  
    "Terms and Conditions":"Termos e Condições",
    " for this platform. ": " para esta plataforma. ",
    "Terms And Conditions": "Termos e Condições",
    "Close": "Fechar",
    "Your email": "Seu email",
    "will be removed and will no longer be used to contact you.":"será removido e não será mais usado para entrar em contato com você.",
    "Please click the button below to confirm.": "Por favor, clique no botão abaixo para confirmar.",
    "Confirm": "confirme",
    "Your email has been successfully removed.":"Seu e-mail foi removido com sucesso.",
    "...processing request": "...em processamento",
    "Privacy Policy | Collinson Group":"Política de Privacidade | Collinson Group",
    "Privacy Policy | The Club":"Política de Privacidade | The Club",
    "Missing flight number.":"Número do voo ausente.",
    "Please enter a flight number":"Por favor insira um número de voo",
    "Please accept the terms and conditions.":"Por favor, aceite os termos e condições.",
    "Flight Number - E.g 1234": "Número do voo - ex: 1234",
    "Flight Airline": "Companhia aérea",
    "Infants under 2 yrs": "Crianças menores de 2 anos",
    "Guest Count": "Número de Convidados",
    "Please select an airline.": "Por favor selecione uma companhia aérea",
    "Please enter the flight number.": "Por favor insira o número do voo.",
    "Please, select a number between 0 and 9.": "Por favor selecione um número entre 0 e 9.",
    "Can't have more than 4 digits.": "Não pode haver mais de 4 dígitos.",
    "Must be above 0.": "Deve ser maior que 0.",
    "Incorrect flight number format.": "Formato do número de voo incorreto.",
    "Programs": "Programas",
    },
}

export { translate }